<style>

	footer {
		font-size: 0.75em;
		letter-spacing: 1px;
		line-height:150%;
		width:100%;
		text-align: center;
	}

</style>


<script>

export let brandName = '';
export let brandCSEmail = '';
export let brandCSLink = '';
export let tokenId = '';
let ekoCSEmail = 'cs@eko.co.in';
let mailSubject = 'Token ' + tokenId + ' issue';

</script>


<footer>

	<div>
		Problem with Token payment? Email us at <a href="mailto:{ekoCSEmail}?subject={mailSubject}">{ekoCSEmail}</a>
	</div>

	{#if brandCSEmail}
		<div>
			Problem with your purchase? Email {brandName} at <a href="mailto:{brandCSEmail}?subject={mailSubject}">{brandCSEmail}</a>
		</div>

	{/if}

</footer>
